import React ,{useState}from 'react';
import './Homepage.css';
import { useNavigate } from 'react-router-dom';


const HomePage = () => {
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);


  return (
    <div className="animated-background">
    <div className="homepage-container">
      {/* Navbar */}
      <div className="blob-bg">
    <div className="blob blob1"></div>
    <div className="blob blob2"></div>
  </div>
      <header className="navbar">
        <div className="logo-section">
    <img src="/eezeelearn_logo_round1a.png"className="logo-image" />
    <span className="logo-text">Eezeelearn</span>
  </div>

   <div className={`nav-toggle ${openMenu ? 'open' : ''}`} onClick={() => setOpenMenu(!openMenu)}>
    <div className="bar"></div>
    <div className="bar"></div>
    <div className="bar"></div>
  </div>
   <ul className={`nav-links ${openMenu ? 'active' : ''}`}>
        <nav className="nav-links">
          <a href="#home">Home</a>
          <a href="#about"></a>
          <a href="#services">Features</a>
          <a href="#blog">Blog</a>
          <a href="#footer">Contact</a>
        </nav>
        </ul>

        <button className="login-btn" onClick={() => navigate('/Signin')}>Login</button>
      </header>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-text">
          <h1>Create. Translate. Narrate. Educate – Instantly with EezeeLearn.</h1>
          <p>
        EezeeLearn is a powerful tool that simplifies the creation and transformation of educational content into engaging, ready-to-use videos. Designed for teachers, content creators, and institutions, it turns raw learning material into structured, multilingual, and narrated video content in just a few clicks.
          </p>
          <div className="hero-buttons">
            <button className="primary-btn" onClick={() => navigate('/Signin')}>Get it started</button>
            <button className="secondary-btn">Learn More</button>
          </div>
        </div>
        <div className="hero-animation">
          <img src="https://cdn-icons-png.flaticon.com/512/1055/1055687.png" alt="hero" />
        </div>
      </section>

      {/* Feature Cards */}
      <section className="features">
        <div className="feature-card">
          <img src="https://cdn-icons-png.flaticon.com/512/1183/1183687.png" alt="Extraction" />
          <p>Text Extraction</p>
        </div>
        <div className="feature-card">
          <img src="https://cdn-icons-png.flaticon.com/512/1055/1055687.png" alt="Summarization" />
          <p>Summarization</p>
        </div>
        <div className="feature-card">
          <img src="https://cdn-icons-png.flaticon.com/512/1183/1183687.png" alt="Translation" />
          <p>Translation</p>
        </div>
        <div className="feature-card">
          <img src="https://cdn-icons-png.flaticon.com/512/1055/1055687.png" alt="Audio Generation" />
          <p>Audio Generation</p>
        </div>
      </section>
      {/* ABOUT SECTION */}
<section id="about" className="about-section">
  <h2> Why EezeeLearn?</h2>
  <p>
   Creating quality educational content takes time, effort, and multiple tools. EezeeLearn simplifies this entire process into a single, intelligent platform — built for educators, institutions, and learning creators.
  </p>
</section>

{/* SERVICES SECTION */}
<section id="services" className="services-section">
  <h2>Key Features</h2>
  {/*<h3> Turn Raw Content into Ready-to-Use Learning Material</h3> */}
  <div className="service-cards">
    <div className="service-card">
      <h3> Extract Clean Text</h3>
      <p>Upload documents or PDFs. EezeeLearn filters out headers, page numbers, and distractions to give you clean educational content.</p>
    </div>
    <div className="service-card">
      <h3> Summarize with Context</h3>
      <p>Get concise, clear summaries that help students focus on what matters most.</p>
    </div>
    <div className="service-card">
      <h3>Translate Effortlessly</h3>
      <p>Translate your content into regional or global languages with accuracy and fluency.</p>
    </div>
    <div className="service-card">
      <h3> Generate Lifelike Audio</h3>
      <p>Transform text into human-like narration in your selected language and tone.</p>
    </div>
  </div>
</section>

{/* BLOG SECTION */}
<section id="blog" className="blog-section">
  <h2>Latest Blog Posts</h2>
  <div className="blog-cards">
    <div className="blog-card">
      <h4>How AI Is Changing Education</h4>
      <p>Explore how artificial intelligence is personalizing the learning experience.</p>
      <a href="/blog/ai-in-education">Read More</a>
    </div>
    <div className="blog-card">
      <h4>Best Tools for Teachers in 2025</h4>
      <p>Discover the top digital tools empowering educators this year.</p>
      <a href="/blog/teacher-tools">Read More</a>
    </div>
  </div>
</section>

  {/* FOOTER SECTION */}
<section id="footer" className="footer-section">
  <h2></h2>
  <p>
  © 2025 EezeeLearn. All rights reserved.
  </p>
</section>

    </div>
    </div>
  );
};

export default HomePage;
